/**
 * #311 — split chip-list input into multiple entries.
 *
 * Splits on commas, semicolons, and newlines (locale-friendly: many EU
 * locales use ';' as the natural list separator). Trims each segment.
 * Drops empties (handles trailing commas, double commas).
 *
 * Dedup happens against:
 *   1. Existing entries (case-insensitive) — so "Knitting, knitting"
 *      added on top of an existing "Knitting" adds nothing.
 *   2. Other entries in the same input — so "knitting, knitting"
 *      adds "knitting" once.
 *
 * Returns the list of NEW entries to append (preserving the order
 * the user typed them). Empty array if there's nothing new.
 *
 * Examples:
 *   splitChipInput("knitting, gardening", []) → ["knitting", "gardening"]
 *   splitChipInput("knitting,gardening", []) → ["knitting", "gardening"]
 *   splitChipInput("knitting, gardening, ", []) → ["knitting", "gardening"]
 *   splitChipInput("  knitting , , gardening ", []) → ["knitting", "gardening"]
 *   splitChipInput("knitting, gardening", ["knitting"]) → ["gardening"]
 *   splitChipInput("knitting, knitting", []) → ["knitting"]
 *   splitChipInput("knitting; gardening", []) → ["knitting", "gardening"]
 *   splitChipInput("knitting\ngardening", []) → ["knitting", "gardening"]
 *   splitChipInput("", []) → []
 *   splitChipInput("   ", []) → []
 */
export function splitChipInput(raw, existingEntries) {
  if (typeof raw !== 'string' || !raw.trim()) return [];
  const existingLower = new Set(
    (existingEntries || []).map(e => String(e).toLowerCase())
  );
  const seenLower = new Set();
  const out = [];
  // Split on comma OR semicolon OR newline (any combination of them).
  const parts = raw.split(/[,;\n]+/);
  for (const part of parts) {
    const trimmed = part.trim();
    if (!trimmed) continue;
    const lower = trimmed.toLowerCase();
    if (existingLower.has(lower) || seenLower.has(lower)) continue;
    seenLower.add(lower);
    out.push(trimmed);
  }
  return out;
}
